import { BaseService, endpoints, http } from './base';
import { ResetPasswordDTO } from '@/pages/auth/dto/resetPasswordForm.dto';
import { IAuth, IProfile } from '@/types';

export class AuthService extends BaseService<IAuth> {
  constructor() {
    super(endpoints.auth.login);
  }

  public async resetPassword(data: ResetPasswordDTO) {
    return http.put(endpoints.auth.resetPassword, data);
  }

  public async getProfile(): Promise<IProfile> {
    const { data } = await http.get(endpoints.auth.profile);
    return data;
  }

  async refreshToken(refreshToken: string) {
    return await http.post(endpoints.auth.refreshToken, { refreshToken });
  }
}
